const StaffData = [
  {
    id: 1,
    qr_code: "img",
    staff_id: "123456",
    id_number: "256",
    full_name: "Siva Kumar Panigrahi",
    mobile: "903247581",
    email: "sivakumar.eee@jntukucev.ac.in",
    active_roles: "CBT Expert",
    working_status: "working",
    attendence: "",
  },
  {
    id: 2,
    qr_code: "img",
    staff_id: "498464",
    id_number: "252",
    full_name: "Siva Kumar Panigrahi",
    mobile: "903247581",
    email: "sivakumar.eee@jntukucev.ac.in",
    active_roles: "CBT Expert",
    working_status: "working",
    attendence: "",
  },
  {
    id: 3,
    qr_code: "img",
    staff_id: "123456",
    id_number: "256",
    full_name: "Siva Kumar Panigrahi",
    mobile: "903247581",
    email: "sivakumar.eee@jntukucev.ac.in",
    active_roles: "CBT Expert",
    working_status: "working",
    attendence: "",
  },
  {
    id: 4,
    qr_code: "img",
    staff_id: "123456",
    id_number: "256",
    full_name: "Siva Kumar Panigrahi",
    mobile: "903247581",
    email: "sivakumar.eee@jntukucev.ac.in",
    active_roles: "CBT Expert",
    working_status: "working",
    attendence: "",
  },
];

export default StaffData;
